import React, { useEffect, useState, useContext, createContext} from 'react';

import { getStuff } from '../helpers/auth'
import { AlertsContext } from './Layout'
import { SummaryItem } from './Overview';
import { authenticatedContext } from '../App'
import { GraphSection } from "./GraphSection";
import { ClientsAidRecords } from './ClientsAidRecords'
import { getTimestamp30DaysAgo, getTimestampToday } from "../helpers/date_conversion"


export const refreshClientProject = createContext();
export const ClientProjectOverview = ({ projectId, clientId }) => {

    const [data, setData] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const addAlertBanner = useContext(AlertsContext);
    const { authenticated, setAuthenticated } = useContext(authenticatedContext);

    useEffect(() => {
        getStuff(`client_cards/${clientId}/${projectId}/`).then((res) => {
                if (res.status === 200) {
                    setData(res.data);
                } else if (res.status === 401) {
                    setAuthenticated(false);
                } else {
                    addAlertBanner("Něco se pokazilo", "danger");
                }
            });
    }, [projectId, clientId, refresh]);

    if (data == null) return "";
    const summaryData = [
        {
            imageSrc: "/img/svg/card_icon_equals.svg",
            mainText: data.aid_count_all,
            subText: "Poskutnutá pomoc celkem",
            change: [],
            alt: "Poskutnutá pomoc celkem",
        },
        {
            imageSrc: "/img/svg/card_icon_30d.svg",
            mainText: data.aid_last_30d + "x",
            subText: "Poskytnutá pomoc za poslední 30 dní",
            change: [data.compare_aid_30d, " oproti minulým 30 dnům"],
            alt: "Pomoc za 30 dní",
        },
        {
            imageSrc: "/img/svg/card_icon_7d.svg",
            mainText: data.aid_last_7d + "x",
            subText: "Poskytnutá pomoc za posledních 7 dní",
            change: [data.compare_aid_7d, " oproti minulým 7 dnům"],
            alt: "Pomoc za posledních 7 dní",
        },
        {
            imageSrc: "/img/svg/card_icon_1d.svg",
            mainText: data.aid_last_1d + "x",
            subText: "Poskytnutá pomoc za posledních 24 hodin",
            change: [data.compare_aid_1d, " oproti minulým 24 hodinám"],
            alt: "Pomoc za 24 hodin icon",
        },
    ];

    
    const emptyAidRecords = {
        for_period: [getTimestamp30DaysAgo(), getTimestampToday()],
        aid_records: []
    }

    return (
        <div className='client-project-overview'>
            <section className="card-section">
                {summaryData.map((item, index) => (
                    <SummaryItem
                        key={index}
                        imageSrc={item.imageSrc}
                        mainText={item.mainText}
                        subText={item.subText}
                        change={item.change}
                        alt={item.alt}
                    />
                ))}
            </section>
                    
            <GraphSection aidRecords={emptyAidRecords}
            reqUrl={`client_aid/${projectId}/${clientId}/`}
            refresh={refresh}/>
            <div className="clients-aid-records">
                <refreshClientProject.Provider value={[refresh, setRefresh]}>
                    <ClientsAidRecords projectId={projectId} clientId={clientId}/>
                </refreshClientProject.Provider>
            </div>
        </div>
    );
};